import { DefaultService } from "@/services/DefaultService";
import API from "@/plugins/axios";

class CambioNombreComercialService extends DefaultService {
  
  constructor() {
    super('cambioNombreComercial');
  }

  cambioNombreComercial(locacion: any, data: any): Promise<any>{
    return API.post(`cambioNombreComercial/${locacion}/cambioNombreComercial`, data);
  }

  getCambioNombreComercial(locacion: any): Promise<any>{
    return API.get(`cambioNombreComercial/${locacion}/getCambioNombreComercial`);
  }

  chageEstatusNombreComercial(locacion: any, solicitud: any, data: any): Promise<any>{
    return API.post(`cambioNombreComercial/${locacion}/chageEstatusNombreComercial/${solicitud}`, data);
  }

  notificarPagoRealizadoNombreComercial(locacion: any, solicitud: any, data: any): Promise<any>{
    return API.post(`cambioNombreComercial/${locacion}/notificarPagoRealizadoNombreComercial/${solicitud}`, data);
  }

  updateCambioNombreComercial(locacion: any, solicitud: any, data: any): Promise<any>{
    return API.post(`cambioNombreComercial/${locacion}/updateCambioNombreComercial/${solicitud}`, data);
  }

  cambioNombreComercialExtra(locacion: any, data: any): Promise<any>{
    return API.post(`cambioNombreComercial/${locacion}/cambioNombreComercialExtra`, data);
  }

  updateCambioNombreComercialExtra(locacion: any, solicitud: any, data: any): Promise<any>{
    return API.post(`cambioNombreComercial/${locacion}/updateCambioNombreComercialExtra/${solicitud}`, data);
  }

  getCambioNombreComercialExtra(locacion: any): Promise<any>{
    return API.get(`cambioNombreComercial/${locacion}/getCambioNombreComercialExtra`);
  }

  deleteCambioNombreComercialExtra(locacion: any, solicitud: any, data: any): Promise<any>{
    return API.post(`cambioNombreComercial/${locacion}/deleteCambioNombreComercialExtra/${solicitud}`, data);
  }

  deleteSolicitudCambioNombreComercial(locacion: any, solicitud: any, data: any): Promise<any>{
    return API.post(`cambioNombreComercial/${locacion}/deleteSolicitudCambioNombreComercial/${solicitud}`, data);
  }
}

export default new CambioNombreComercialService;